import { Flex, Text } from '@chakra-ui/react';
import React from 'react';

export const ComapanyJobs = ({ item, recruiter, image }) => {
  return (
    <Flex
      align='center'
      gap={2}
      my={5}
      border={'1px solid #DDDDDD'}
      padding={2}
      borderRadius={15}
    >
      <Flex border={'1px solid #DDDDDD'} className='radius-50' padding={1}>
        <img
          src={image}
          alt='company'
          className='radius-50'
          style={{ width: '51px', height: '51px', objectFit: 'cover' }}
        />
      </Flex>
      <Flex direction='column'>
        <Text
          textAlign={'left'}
          color={'#6D6675'}
          fontWeight={'bold'}
          textTransform={'capitalize'}
        >
          {/* {postData?.createdBy.name} */}
          {item?.jobRoleTitle}
        </Text>
        <Flex>
          <Text color={'#6D6675'}>
            {/* {postData?.createdBy?.jobTitle || "HR Manager"} */}
            {recruiter}
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
};
